import styled from 'styled-components';


// About

export const ProfileBox = styled.div`
    margin: auto;
    width: min(80vw, 700px);
    padding: min(5vw, 30px);
    margin-top: min(5vw, 30px);
    display: flex;
    flex-direction: column;
    align-items: center;

    border: 1px solid 242,242,242;
    border-radius: 10px;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
    background-color: rgba(243,244,246, 0.3);
    backdrop-filter: blur(10px) saturate(100%) contrast(45%) brightness(130%);

    img{
        width: min(35vw, 250px);
        border-radius: 10px;
        box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
        background-color: rgba(242,242,242, 0.3);
        backdrop-filter: blur(10px) saturate(100%) contrast(45%) brightness(130%);
    }

    p{
        margin: 0;
        margin-bottom: .5vw;
    }

    a{
        width: min(10vw, 50px);
        line-height: 0;
        padding: 1vw;

        img{
            width: 100%;
            padding: .1vw;
        }
    }
`;

export const HighlightWrapper = styled.div`
    width: 100%;
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    row-gap: min(3vw, 20px);

    img{
        width: min(7vw, 30px);
        padding: min(2vw, 10px);
    }

    @media only screen and (max-width: 600px) {
        grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
    }
`;

export const SocialWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`;


// Projects

export const ProjectWrapper = styled.div`

    width: 90%;
    padding: 10% 5% 10% 5%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    row-gap: 10vw;
    column-gap: 5vw;
`;

export const ProjectBackground = styled.div`

    width: min(80vw, 350px);
    margin: auto;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
`;

export const ProjectCard = styled.div`

    width: 90.1%;
    height: 500px;
    padding: 5%;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: rgba(243,244,246, 0.5);
    backdrop-filter: blur(10px) saturate(100%) contrast(45%) brightness(130%);

    a{
        width: 50%;
        margin: auto;
        text-decoration: none;
        color: inherit;
        text-align: center;
        cursor: pointer;
        border-radius: 5px;
        box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
        background-color: rgba(242,242,242, 0.3);
        backdrop-filter: blur(10px) saturate(100%) contrast(45%) brightness(130%);
    }
`;

export const FrameworkWrapper = styled.div`
    
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: min(5vw, 10px);

    img{
        width: min(10vw, 35px);
        margin-left: min(5vw, 20px);
    }
`;

export const YearWrapper = styled.div`

    width: 100%;
    display: flex;
    justify-content: center;
    font-size: min(2vw, 12px);
`;

export const DescriptionWrapper = styled.div`

    height: 50%;
    overflow: hidden;
    border: 1px solid #e0e0e0;

    p{
        padding: 0 1vw 0 1vw;
    }
`;

export const Circle = styled.div`
    width: min(5vw, 20px);
    height: min(5vw, 20px);
    border-radius: 50%;
    margin-right: min(5vw, 10px);
`;


// Timeline

export const TimeLine = styled.div`
    width: 100%;
    display: flex;
`;

export const TimeLineObject = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    p{
        font-size: min(2vw, 12px);
        white-space: pre-wrap;
    }

    p[id=company]{
        text-align: center;
        line-height: 30px;
    }

    @media only screen and (max-width: 600px) {
        p[id=company]{
            line-height: 10px;
        }
    }
`;

export const Line = styled.div`
    height: 2px;
    background: #A8A8A8;
`;

export const LineMark = styled.div`
    position: absolute;
    left: min(1.5vw, 10px);
    bottom: -4px;
    width: 10px;
    height: 10px;
    background: #A8A8A8;
    border-radius: 50%;
`;